import PropTypes from "prop-types";

const DefinitionCard = ({ title, explanation }) => {
  return (
    <div className="definitions__card">
      <div className="definitions__card-heading-wrapper">
        <h3 className="definitions__card-heading">{title}</h3>
      </div>
      <div className="definitions__card-content">{explanation}</div>
    </div>
  );
};

DefinitionCard.propTypes = {
  title: PropTypes.string.isRequired,
  explanation: PropTypes.string.isRequired,
};

export default DefinitionCard;
